import React, { useState, useCallback, useEffect } from "react";
import { InstantSearchOverlay } from "./InstantSearchOverlay";
import { useSearch } from "@usereactify/search";
import { useHideHelpBtn } from "../../hooks/useHideHelpBtn";

export const InstantSearch: React.FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { setSearchTerm } = useSearch();
  const { hideHelpBtn, showHelpBtn } = useHideHelpBtn();
  const toggleIsOpen: () => void = useCallback(() => setIsOpen(!isOpen), [isOpen]);
  const onIsOpen: () => void = () => {
    const searchForm = document.body.querySelector<HTMLInputElement>(".reactify-search-input");
    hideHelpBtn();
    if (searchForm) searchForm.focus();
  };
  const onIsClosed: () => void = () => {
    showHelpBtn();
    setSearchTerm("");
  };

  useEffect(() => {
    isOpen ? onIsOpen() : onIsClosed();
  }, [isOpen]);

  return (
    <>
      <InstantSearchOverlay isOpen={isOpen} toggleIsOpen={toggleIsOpen} />
    </>
  );
};
